<template>
    <div class="px-5 py-0 flex space-x-5">
        <div class="text-lg font-mono text-taupe-500">
            {{ falseValue.display }}
        </div>
        <div>
            <button
                :disabled="readOnly"
                type="button"
                @click="toggle"
                :class="toggleStyle"
                class="cursor-pointer relative inline-flex h-6 w-11 shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-hidden focus:ring-2 focus:ring-sky-500 focus:ring-offset-2"
                role="switch"
                :aria-checked="isTrue ? 'true' : 'false'"
            >
                <span class="sr-only">{{ label }}</span>
                <span
                    aria-hidden="true"
                    :class="isTrue ? 'translate-x-5' : 'translate-x-0'"
                    class="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-sm ring-0 transition duration-200 ease-in-out"
                ></span>
            </button>
        </div>
        <div class="text-lg font-mono text-taupe-500">
            {{ trueValue.display }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'BooleanTargetToggle',
    computed: {
        isFalse() {
            return !this.isTrue
        },
        isTrue() {
            return this.trueValue.display === this.currentValue.display
        },
        toggleStyle() {
            if (this.isTrue) {
                return (
                    'bg-sky-600 ' +
                    (this.readOnly ? 'cursor-not-allowed' : 'cursor-pointer')
                )
            } else {
                return (
                    'bg-taupe-200 ' +
                    (this.readOnly ? 'cursor-not-allowed' : 'cursor-pointer')
                )
            }
        },
    },
    methods: {
        toggle() {
            this.$emit('toggle', this.isTrue ? this.falseValue : this.trueValue)
        },
    },
    props: {
        readOnly: {
            type: Boolean,
            required: false,
            default: false,
        },
        label: {
            type: String,
            required: false,
            default: 'Use setting',
        },
        currentValue: {
            type: Object,
            required: true,
        },
        falseValue: {
            type: Object,
            required: true,
        },
        trueValue: {
            type: Object,
            required: true,
        },
    },
}
</script>
